import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const OrdsInfoplanReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(Types.OBTENER_ESPECIALIDADES_MEDICAS_LOADING, (state) => {
      state.obtenerEspecialidadesMedicasLoading = true;
      state.obtenerEspecialidadesMedicasError = null;
    })
    .addCase(Types.OBTENER_ESPECIALIDADES_MEDICAS_SUCCESS, (state, action) => {
      const { obtenerEspecialidadesMedicasData } = action;
      state.obtenerEspecialidadesMedicasData = obtenerEspecialidadesMedicasData;
      state.obtenerEspecialidadesMedicasLoading = false;
      state.obtenerEspecialidadesMedicasError = null;
    })
    .addCase(Types.OBTENER_ESPECIALIDADES_MEDICAS_FAILURE, (state, action) => {
      const { obtenerEspecialidadesMedicasError } = action;
      state.obtenerEspecialidadesMedicasData = INITIAL_STATE.obtenerEspecialidadesMedicasData;
      state.obtenerEspecialidadesMedicasLoading = false;
      state.obtenerEspecialidadesMedicasError = obtenerEspecialidadesMedicasError;
    });
});

